import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const SingleActionMenuItem = ({ label, command, separator, className, onClick, data }) => {
  const linkClass = classNames(className, {})
  return (
    <li className={linkClass}>
      <a onClick={() => onClick(data, command)}>{label}</a>
    </li>
  )
}

SingleActionMenuItem.defaultProps = {
  separator: false
}

SingleActionMenuItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  command: PropTypes.string,
  separator: PropTypes.bool,
  className: PropTypes.string
}
